import { Axios } from "axios";
import { z } from "zod";
import { httpClient } from "@/common/http-client";
import { CsmCompaniesRoute } from "@/common/csm-endpoints";
import {
    CsmCompanyDto,
    csmCompanySchema,
} from "@/modules/authentication/schemas/csm-company-schema";

export class CsmCompaniesRepository {
    constructor(private readonly _httpClient: Axios) {}

    fetchAll = async (): Promise<ReadonlyArray<CsmCompanyDto>> => {
        const response = await this._httpClient.get<unknown>(
            CsmCompaniesRoute.fetchAll(),
            {
                params: { random: Date.now().toString() },
            },
        );
        return z.array(csmCompanySchema).readonly().parse(response.data);
    };
}

export const csmCompaniesRepository = new CsmCompaniesRepository(httpClient);
